import { IonIcon, IonLabel } from '@ionic/react'
import { flash, logoEuro, swapHorizontal } from 'ionicons/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { logEvent } from '../../../../../analytics/utils/firebaseUtils'
import { ChartModes } from '../types/types'

interface ConsumptionChartButtonsProps {
	panelLinked: boolean
	consumptionBreakdownRef?: any
	chartModes: ChartModes
	setChartModes: React.Dispatch<React.SetStateAction<ChartModes>>
	hasTransferPricesSettings: boolean
	showTitle?: boolean
}

const ConsumptionChartButtons: React.FC<ConsumptionChartButtonsProps> = ({
	panelLinked,
	consumptionBreakdownRef,
	chartModes,
	setChartModes,
	hasTransferPricesSettings,
	showTitle,
}) => {
	const { t } = useTranslation('pages_electricity')

	const activeStyle =
		'button text-brand-secondary-100-light dark:text-white dark:[&>ion-icon]:bg-brand-primary-100-dark [&>ion-icon]:bg-brand-primary-100-light [&>ion-icon]:text-white hover'
	const inactiveStyle =
		'button text-[#707070] dark:text-brand-primary-100-dark dark:[&>ion-icon]:bg-[#144448] [&>ion-icon]:bg-[#e5e5e5] [&>ion-icon]:text-[#a3a3a3] dark:[&>ion-icon]:text-brand-primary-100-dark hover'

	return (
		<div className='chart-buttons w-full flex flex-col gap-4 bg-white dark:bg-[#0d2d30]'>
			{showTitle && (
				<span className='p-2 text-md tracking-wide text-text-dark dark:text-white'>
					{t('chartButtons.title')}
				</span>
			)}
			<div className='flex flex-row items-center justify-around gap-2'>
				<div
					className={
						chartModes.exchangePrices ? `${activeStyle} prices` : `${inactiveStyle} prices`
					}
					onClick={() => {
						logEvent('click-chart-include-hourly-price', { value: !chartModes.exchangePrices })
						setChartModes(state => ({ ...state, exchangePrices: !state.exchangePrices }))
					}}
				>
					<IonIcon icon={logoEuro} />
					<IonLabel className='tracking-wide'>{t('chartButtons.tuntihinnat')}</IonLabel>
				</div>

				{panelLinked && (
					<div
						className={chartModes.production ? activeStyle : inactiveStyle}
						onClick={() => {
							logEvent('click-chart-include-production', { value: !chartModes.production })
							setChartModes(state => ({ ...state, production: !state.production }))
						}}
					>
						<IonIcon icon={flash} />
						<IonLabel className='tracking-wide' ref={consumptionBreakdownRef}>
							{t('chartButtons.tuotto')}
						</IonLabel>
					</div>
				)}

				{hasTransferPricesSettings && (
					<div
						className={chartModes.transferPrices ? activeStyle : inactiveStyle}
						onClick={() => {
							setChartModes(state => ({ ...state, transferPrices: !state.transferPrices }))
						}}
					>
						<IonIcon icon={swapHorizontal} />
						<IonLabel className='tracking-wide' ref={consumptionBreakdownRef}>
							{t('chartButtons.transferprices')}
						</IonLabel>
					</div>
				)}
			</div>
		</div>
	)
}
export default ConsumptionChartButtons
